export function addColumn(schema, column) {
    return addColumns(schema, [column]);
}
export function addColumns(schema, columns) {
    const newSchema = [];
    const colNames = schema.map((col) => col.name);
    for (const column of columns) {
        if (!colNames.includes(column.name)) {
            newSchema.push(column);
        }
    }
    newSchema.push(...schema);
    return newSchema;
}
export function removeColumn(schema, columnName) {
    return schema.filter((column) => column.name !== columnName);
}
export function removeColumns(schema, columnNames) {
    return schema.filter((column) => !columnNames.includes(column.name));
}
export function updateColumn(schema, column) {
    return schema.map((c) => (c.name === column.name ? column : c));
}
export function prepareSchemasResponse(response) {
    response = response.map((s) => {
        return Object.keys(s).reduce((acc, k) => {
            if (k.toLowerCase() === 'schema') {
                acc[k.toLowerCase()] = JSON.parse(s[k]);
            }
            else {
                acc[k.toLowerCase()] = s[k];
            }
            return acc;
        }, {});
    });
    return response;
}
